import React from 'react'
import SearchForm from './components/SearchForm'
import Buttons from './components/Buttons'
import Stories from './components/Stories'
function App() {
  return <>
    <SearchForm/>
    <Buttons/>
    <Stories/>
  </>
}

export default App
